<template>
  <div class="translation-menu">
    <v-menu
      v-if="hasLanguages"
      :close-on-content-click="false"
      offset-y
      light
      transition="slide-y-transition"
    >
      <template #activator="{on}">
        <div
          data-testid="translation-selector"
          class="flag-wrapper"
          v-on="on"
        >
          <img
            :src="require(`./assets/${activeLanguage.key}.png`)"
            :alt="activeLanguage.name"
            :title="activeLanguage.name"
            class="flag-wrapper__icon"
          >
          <svg class="flag-wrapper__indicator" viewBox="0 0 24 24">
            <path fill="currentColor" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
          </svg>
        </div>
      </template>

      <v-list-item
        v-for="language in languages"
        :key="language.key"
        @click="changeLanguage(language.key)"
      >
        <v-list-item-content
          :data-testid="`language-option-${language.key}`"
        >
          <v-list-item-title :class="{ active: isItemActive(language) }">{{ language.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-menu>
  </div>
</template>

<script>

export default {
  name: 'StTranslationMenu',
  props: {
    languages: {
      type: Array,
      default: () => [{
        key: 'pt',
        name: 'Português',
      }],
    },
    initialOption: {
      type: String,
      default: 'pt',
    },
  },
  data() {
    return {
      activeLanguage: {},
    };
  },
  computed: {
    hasLanguages() {
      return this.languages.length > 0;
    },
  },
  created() {
    this.changeLanguage(this.initialOption);
  },
  methods: {
    changeLanguage(key) {
      this.activeLanguage = this.languages.find(lang => lang.key === key);
      this.$emit('change', this.activeLanguage);
    },
    isItemActive(item) {
      return item.key === this.activeLanguage.key;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@stilingue/st-styles/colors.scss';

  .translation-menu {
    .flag-wrapper__icon {
      width: 27px;
      height: 27px;
      border-radius: 50%;
    }

    .flag-wrapper {
      height: 30px;
      margin: 5px;
    }

    .flag-wrapper__indicator {
      width: 20px;
      padding-bottom: 2px;
      margin-left: 3px;
    }
  }

  .v-menu__content {
    background: white;
    width: 160px;
    transform: translate(-105px, 10px);

    .v-list-item {
      margin: 5px;
    }

    .v-list-item__content {
      padding: 0;
    }

    .v-list-item__title {
      line-height: 1.3;

      &.active {
        color: var(--green-agua-400);
      }
    }
  }
</style>
